import React from "react";
import { cn } from "@/lib/utils";

function Label({ className, children, htmlFor }) {
  return (
    <label htmlFor={htmlFor} className={cn("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70", className)}>
      {children}
    </label>
  );
}

export { Label };